<template>
  <div>
    <el-date-picker
      v-model="ruleForm.legalPersonCardValidityStart"
      @change="changePicker"
      :clearable="false"
      align="right"
      type="daterange"
      range-separator="至"
      start-placeholder="开始日期"
      end-placeholder="结束日期"
    >
    </el-date-picker>
  </div>
</template>

<script>
export default {
  data() {
    return {
      ruleForm: {
        // 法人证件号码有效期
        legalPersonCardValidityStart: "",
        legalPersonCardValidityEnd: "",
      },
    };
  },
  methods: {},
};
</script>

<style></style>
